module.exports = __webpack_public_path__ + "static/img/productPartner_11_1.aa6f087.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/productService/productPartner/productPartner_11_1.png
// module id = 1yDo
// module chunks = 34